import { useQuery } from '@tanstack/react-query';
import { api } from '../client';
import { queryKeys } from '../query-keys';

export function useMarketComponentTypesSelect() {
  return useQuery({
    queryKey: queryKeys.marketComponentTypes.all,
    queryFn: async () => {
      const res = await api.marketComponentTypeApi.apiMarketComponentTypesGetCollection();
      return res.data;
    },
    meta: {
      skipGlobalError: false,
    },
  });
}
